import { useState, useEffect } from 'react';
import './Staffing.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Adv1 from '../../assets/adv1.jpg';
import Adv5 from '../../assets/adv5.jpg';
import Adv6 from '../../assets/adv6.jpg';
import Point3 from '../../assets/point3.png';
import Point4 from '../../assets/point4.png';
import Point5 from '../../assets/point5.png';
import Point6 from '../../assets/point6.png';
import Point9 from '../../assets/point9.png';
import Point14 from '../../assets/point14.png';
import Point15 from '../../assets/point15.png';
import Point16 from '../../assets/point16.png';
import Clients from '../../components/Clients';
import Background from '../../assets/background.jpg';
import Reviews from '../../components/Reviews';
import Form from '../../components/Form';
import Img1 from './img1.jpg';
import Img2 from './img2.jpg';
import Img3 from './img3.jpg';
import WhoWeHire from '../../components/WhoWeHire';

const Staffing = ({ onFormClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isFormOpen, setFormOpen] = useState(false);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='mainScreen'>
        <span className='mainScreenTitle'>
          Your guide to <b>finding</b> <span>{isMobile ? 'hiring the right person.' : 'hiring the right person.'}</span>
        </span>
        <span className='mainScreenText'>
          We don’t just stop at presenting candidates, we’re with you through the entire process, from offer acceptance to
          ensuring your new hire thrives at their job.
        </span>
      </div>

      <div className='staffingCardsSection'>
        <span className='staffingCardsSectionTitle'>
          High-performing talent.
          <br /> Fast, flexible, and built for growth.
        </span>
        <span className='staffingCardsSectionText'>
          At NextDeavor, we help you find the right people,  not just resumes. Whether you need short-term support or permanent
          team members, our staffing solutions are built to move fast without sacrificing quality.
        </span>
        <div className='staffingCards'>
          <div className='staffingCard'>
            <div className='staffingCardImage'>
              <img src={Img1} />
            </div>
            <span className='staffingCardTitle'>Contract Staffing</span>
            <span className='staffingCardText'>Flexible, on-demand talent to keep your projects moving.</span>
            <span className='staffingCardInfo'>
              Perfect for scaling teams quickly or filling urgent gaps, our contract staffing solution delivers vetted
              professionals who hit the ground running — without the overhead.
              <ul>
                <li>Speed: Talent delivered in days, not weeks</li>
                <li>Compliance handled for you (payroll, onboarding, HR)</li>
                <li>Ideal for project work, peak seasons, or specialized needs</li>
              </ul>
            </span>
          </div>

          <div className='staffingCard'>
            <div className='staffingCardImage'>
              <img src={Img2} />
            </div>
            <span className='staffingCardTitle'>Direct Hire</span>
            <span className='staffingCardText'>Long-term hires, matched for skill and culture.</span>
            <span className='staffingCardInfo'>
              We don’t just check boxes — we help you hire people who thrive in your environment and grow with your team.
              <ul>
                <li>AI-powered sourcing + recruiter intuition</li>
                <li>Fewer resumes, better matches</li>
                <li>Roles in tech, engineering, marketing, finance, and HR</li>
              </ul>
            </span>
          </div>

          <div className='staffingCard'>
            <div className='staffingCardImage'>
              <img src={Img3} />
            </div>
            <span className='staffingCardTitle'>Contract-to-Hire</span>
            <span className='staffingCardText'>Try before you commit.</span>
            <span className='staffingCardInfo'>
              Need flexibility, but want to test long-term fit? Our contract-to-hire model lets you evaluate performance in
              real-time before making a full-time offer.
              <ul>
                <li>Reduce hiring risk</li>
                <li>Ensure technical + cultural alignment</li>
                <li>Seamless conversion to full-time when ready</li>
              </ul>
            </span>
          </div>
        </div>
      </div>

      <WhoWeHire />

      <div className='stepsSection'>
        <span className='blockTitle'>Our Innovative Process</span>
        <div className='stepsTags'>
          <span className='stepsTag stepsTag1'>AI-powered search</span>
          <span>+</span>
          <span className='stepsTag stepsTag2'>Strategic market research</span>
          <span>+</span>
          <span className='stepsTag stepsTag3'>Competitive positioning</span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point9} />
          </span>
          <span className='stepTitle'>
            <span>1.</span>Intake Meeting
          </span>
          <span className='stepText'>
            Our team meets with you to determine what your goals for your open position are and get a feel for the culture of your
            company.
          </span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point14} />
          </span>
          <span className='stepTitle'>
            <span>2.</span>Market Insights Presentation
          </span>
          <span className='stepText'>
            We create a detailed breakdown of the talent market for your open position, including suggestions for improving your
            job description to stand out from the competition.
          </span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point4} />
          </span>
          <span className='stepTitle'>
            <span>3.</span>AI-Powered Initial Search
          </span>
          <span className='stepText'>
            Our AI tech gets to work, identifying, reaching out to, and following up with candidates. It’s faster and more
            extensive than manual searches to boost the chances of securing a perfect candidate.
          </span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point15} />
          </span>
          <span className='stepTitle'>
            <span>4.</span>Conversations With Candidates
          </span>
          <span className='stepText'>
            Your recruiter has honest conversations with our short-list of candidates to pinpoint who the best matches are and
            weed out poor culture fits, tire kickers, or those who lack proven skills.
          </span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point14} />
          </span>
          <span className='stepTitle'>
            <span>5.</span>Candidate Presentation
          </span>
          <span className='stepText'>
            We advocate for our top choices to show you why we believe they will be great additions to your team beyond what you
            see on their resume.
          </span>
        </div>
        <div className='step'>
          <span className='stepIcon'>
            <img src={Point16} />
          </span>
          <span className='stepTitle'>
            <span>6.</span>Closing & Post-Placement Support
          </span>
          <span className='stepText'>
            As the top candidates go through your interview and hiring process, we’re there to get in front of anything that could
            jeopardize placement — like another offer on the table.
          </span>
        </div>
      </div>

      <div className='categories' style={{ marginBottom: '0' }}>
        <div className='category'>
          <span className='categoryIcon'>
            <img src={Point4} />
          </span>
          <span className='categoryText'>AI-enhanced sourcing with human vetting</span>
        </div>
        <div className='category'>
          <span className='categoryIcon'>
            <img src={Point5} />
          </span>
          <span className='categoryText'>Faster time to productivity</span>
        </div>
        <div className='category'>
          <span className='categoryIcon'>
            <img src={Point6} />
          </span>
          <span className='categoryText'>Real partnership — not transactional recruiting</span>
        </div>
        <div className='category'>
          <span className='categoryIcon'>
            <img src={Point3} />
          </span>
          <span className='categoryText'>Market insights to help guide your hiring strategy</span>
        </div>
      </div>

      <div className='clientsSection'>
        <span className='blockTitle'>Recent Clients Include…</span>
        <Clients />
      </div>

      <div className='adBlock'>
        <span className='adBlockBackgroung'>
          <img src={Background} />
        </span>
        <div className='adBlockDetails'>
          <span className='adBlockTitle'>Let’s Build Your Team</span>
          <span className='adBlockText'>Whether you need one key player or a full project team, we’ve got you covered.</span>
        </div>
        <span className='adBlockButton' onClick={() => setFormOpen(true)}>
          Email our sales team
          <svg width='28' height='28' viewBox='0 0 28 28'>
            <path
              d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3718 10.9841 24.1724 8.09271 22.0398 5.96018C19.9073 3.82764 17.0159 2.62818 14 2.625ZM18.9941 14.6191L15.4941 18.1191C15.3299 18.2833 15.1072 18.3755 14.875 18.3755C14.6428 18.3755 14.4201 18.2833 14.2559 18.1191C14.0918 17.9549 13.9995 17.7322 13.9995 17.5C13.9995 17.2678 14.0918 17.0451 14.2559 16.8809L16.263 14.875H9.62501C9.39294 14.875 9.17038 14.7828 9.00629 14.6187C8.84219 14.4546 8.75001 14.2321 8.75001 14C8.75001 13.7679 8.84219 13.5454 9.00629 13.3813C9.17038 13.2172 9.39294 13.125 9.62501 13.125H16.263L14.2559 11.1191C14.0918 10.9549 13.9995 10.7322 13.9995 10.5C13.9995 10.2678 14.0918 10.0451 14.2559 9.88094C14.4201 9.71675 14.6428 9.62451 14.875 9.62451C15.1072 9.62451 15.3299 9.71675 15.4941 9.88094L18.9941 13.3809C19.0754 13.4622 19.14 13.5587 19.184 13.6649C19.228 13.7712 19.2507 13.885 19.2507 14C19.2507 14.115 19.228 14.2289 19.184 14.3351C19.14 14.4413 19.0754 14.5378 18.9941 14.6191Z'
              fill='white'
            />
          </svg>
        </span>
      </div>
      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default Staffing;
